import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Slider from '@material-ui/core/Slider'
import { Typography } from '@material-ui/core'
import { t as i18n } from 'ttag'

const useStyles = makeStyles(theme => ({
  root: {
    width: 450,
    marginTop: theme.spacing(4)
  },
  margin: {
    height: theme.spacing(3)
  }
}))

const marks = [
  {
    value: 0,
    label: '0%'
  },
  {
    value: 20,
    label: '20%'
  },
  {
    value: 37,
    label: '37%'
  },
  {
    value: 100,
    label: '100%'
  }
]

function valuetext(value) {
  return `${value}%`
}

function valueLabelFormat(value) {
  return marks.findIndex(mark => mark.value === value) + 1
}

const DiscreteSlider = () => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <Typography>{i18n`Slide to adjust the intensity`}</Typography>
      <Slider
        defaultValue={30}
        getAriaValueText={valuetext}
        aria-labelledby='discrete-slider'
        valueLabelDisplay='auto'
        step={10}
        marks
        min={10}
        max={110}
      />
    </div>
  )
}

export default DiscreteSlider
